// Autogenerated file
export const bidPointOptionFlagsEnum = {
    None: "None",
    UsesStrictPlanEnter: "UsesStrictPlanEnter",
    EmptyMileagePoint: "EmptyMileagePoint",
    EstimatedDateAsPlanned: "EstimatedDateAsPlanned",
};
export const bidPointOptionFlags = [
    { label: "Без опций", value: "None", intValue: 0 },
    { label: "Выгрузка строго по заданию", value: "UsesStrictPlanEnter", intValue: 1 },
    { label: "Точка порожнего маршрута", value: "EmptyMileagePoint", intValue: 2 },
    { label: "Дата была изменена на расчетную", value: "EstimatedDateAsPlanned", intValue: 4 },
];
